import alt from 'framework/alt';

class VerifiedProfileActions {
  constructor() {
    this.generateActions(
      'fetchVerifiedProfileSucceeded',
      'fetchVerifiedProfileFailed',
      'fetchClaimedEntitySucceeded',
      'fetchClaimedEntityFailed',
      'fetchAuthorIdentitySucceeded',
      'fetchAuthorIdentityFailed',
      'fetchAccountPoolSucceeded',
      'fetchAccountPoolFailed',
    );
  }
}

export default alt.createActions(VerifiedProfileActions);
